import '../styles/sidebars.css'

const SideBar = () => {
    return (
        <div className="fixed top-0 right-0 w-screen h-12 m-0 flex flex-row bg-red-500/95 hover:bg-red-600/95 text-white shadow-lg pl-7 pt-1">
            <b>Northeastern Dining</b>
            <i className='fixed top-0 left-0 w-screen pt-1'>Rate Northeastern's Dining</i>
        </div>
    );
};

export default SideBar;